import { DadosComparativoDireto } from '@/features/laudo/types/laudo-wizard.types';

export const calcularValorM2 = (valorAnuncio: number, area: number): number => {
  if (!area || area <= 0) return 0;
  if (!valorAnuncio || valorAnuncio <= 0) return 0;
  return valorAnuncio / area;
};

// FAT é a soma de desvios dos fatores de homogeneização (sem oferta).
// O fator de oferta é aplicado separadamente em calcularValorHomogeneizado,
// alinhando com a fórmula da Tabela de Valor de Terreno (NBR 14653 trata oferta
// como ajuste de mercado, distinto dos fatores de homogeneização do imóvel).
export const calcularFAT = (item: DadosComparativoDireto, parametros: string[]): number => {
  let somaDesvios = 0;

  if (parametros.includes('regiao')) somaDesvios += (item.fatorRegiao || 1.0) - 1.0;
  if (parametros.includes('andar')) somaDesvios += (item.fatorAndar || 1.0) - 1.0;
  if (parametros.includes('vaga')) somaDesvios += (item.fatorVaga || 1.0) - 1.0;
  if (parametros.includes('area')) somaDesvios += (item.fatorArea || 1.0) - 1.0;
  if (parametros.includes('padraoAcabamento')) somaDesvios += (item.fatorPadraoAcabamento || 1.0) - 1.0;
  if (parametros.includes('estadoConservacao')) somaDesvios += (item.fatorEstadoConservacao || 1.0) - 1.0;
  if (parametros.includes('fatorExtraI')) somaDesvios += (item.fatorExtraI || 1.0) - 1.0;
  if (parametros.includes('fatorExtraII')) somaDesvios += (item.fatorExtraII || 1.0) - 1.0;
  if (parametros.includes('fatorExtraIII')) somaDesvios += (item.fatorExtraIII || 1.0) - 1.0;

  const fat = 1.0 + somaDesvios;

  // Garante que FAT nunca seja 0 (mínimo 0.01)
  return Math.max(fat, 0.01);
};

export const calcularValorHomogeneizado = (
  valorM2: number,
  fat: number,
  fatorOferta: number,
): number => {
  if (!valorM2 || valorM2 <= 0) return 0;
  if (!fat || fat <= 0) return 0;
  const oferta = fatorOferta && fatorOferta > 0 ? fatorOferta : 1.0;
  return valorM2 * oferta * fat;
};
